const RECORDER_MIME_CANDIDATES = [
  'video/webm;codecs=vp9',
  'video/webm;codecs=vp8',
  'video/webm',
  'video/mp4'
] as const

export default function getSupportedVideoMimeType(): string {
  if (typeof MediaRecorder === 'undefined') {
    return RECORDER_MIME_CANDIDATES[0]
  }

  for (const mimeType of RECORDER_MIME_CANDIDATES) {
    if (MediaRecorder.isTypeSupported(mimeType)) {
      return mimeType
    }
  }

  return RECORDER_MIME_CANDIDATES[0]
}
